export interface SalesOrderDocumentStatusItem {
  id: string;
  orderStatus: string;
  user: string;
  processedDate: Date;
  reportType: string;
}
